var map = {
	"./australia_a_league.jpg": "89Eo",
	"./common.jpg": "pvwo",
	"./la_liga.jpg": "zUTF",
	"./old/la_liga.jpg": "Y3Li",
	"./old/premier_league.jpg": "bWps",
	"./old/wolves-1026.jpg": "5OXt",
	"./old/wolves.jpg": "i1tq",
	"./premier_league.jpg": "YhU6",
	"./wolves.jpg": "SQo4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W4RS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg ^\.\/.*\.jpg$
// module id = W4RS
// module chunks = 1